import { IBundleConfiguration } from "../../models/configuration/bundles/IBundles";
import { Action, ActionType } from "../actions";

interface ConfigBundlesReducer {
  loading: boolean;
  error: string | null;
  data: IBundleConfiguration | null;
  persistedData: IBundleConfiguration | null;
}

const initialState = { loading: false, error: null, data: null, persistedData: null };

const cloneBundleConfig = (payload: IBundleConfiguration | null): IBundleConfiguration | null => {
  if (!payload) return payload;
  return JSON.parse(JSON.stringify(payload)) as IBundleConfiguration;
};

const configDocumentBundlesReducer = (
  state: ConfigBundlesReducer = initialState,
  action: Action
): ConfigBundlesReducer => {
  switch (action.type) {
    // GET DATA
    case ActionType.GET_CONFIG_BUNDLE_DATA:
      return { ...state, loading: true, error: null };
    case ActionType.GET_CONFIG_BUNDLE_DATA_FAILURE:
      return { ...state, loading: false, error: action.payload, persistedData: state.persistedData };
    case ActionType.GET_CONFIG_BUNDLE_DATA_SUCCESS: {
      const persistedData = action.fromServer
        ? cloneBundleConfig(action.payload)
        : state.persistedData;
      return { ...state, loading: false, error: null, data: action.payload, persistedData };
    }

    // SAVE DATA
    case ActionType.SAVE_CONFIG_BUNDLE_DATA:
      return { ...state, loading: true, error: null, data: state.data };
    case ActionType.SAVE_CONFIG_BUNDLE_DATA_FAILURE:
      return { ...state, loading: false, error: action.payload, data: state.data, persistedData: state.persistedData };
    case ActionType.SAVE_CONFIG_BUNDLE_DATA_SUCCESS:
      return { ...state, loading: false, error: null, data: action.payload, persistedData: cloneBundleConfig(action.payload) };

    case ActionType.CONFIG_ID_CHANGED:
      return initialState;
    default:
      return state;
  }
};

export default configDocumentBundlesReducer;